export const notificationEndpoints = {
  getNotifications: '/private/v1/notifications',
  markRead: (id: string) => `/private/v1/notifications/${id}/status`,
  markAllRead: '/private/v1/notifications/status',
} as const;

export type NotificationEndpointKey = keyof typeof notificationEndpoints;
